/** @format */

import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	AfterViewInit,
	OnChanges,
	HostListener,
	SimpleChanges,
	ChangeDetectorRef,
} from '@angular/core';
import { Attachment } from '../../models/attachment';
import { UntypedFormGroup, FormControl, UntypedFormBuilder } from '@angular/forms';
import { User } from 'src/app/state-management';

@Component({
	selector: 'app-attachments',
	templateUrl: './attachments.component.html',
	styleUrls: ['./attachments.component.css'],
	standalone: false,
})
export class AttachmentsComponent implements OnInit, OnChanges {
	@Input() attachments: Attachment[];
	@Input() users: User[];
	@Input() isBatchExport: boolean;
	@Input() isCityworksRequest: boolean;
	@Output() openAttachment = new EventEmitter<{ docNum: number; desc: string }>();
	@Output() deleteAttachment = new EventEmitter<Attachment>();
	@Output() updateAttachDescription = new EventEmitter<Attachment>();
	quillEditors: Array<{ key: number; editor: any }> = [];

	fg: UntypedFormGroup;
	quillIntervalTimers: { [key: number]: any } = {};

	constructor(private fb: UntypedFormBuilder, private changeDetectorRef: ChangeDetectorRef) {}

	ngOnInit() {
		if (!this.fg) {
			this.fg = this.createGroup();
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!this.isBatchExport && changes.attachments) {
			if (!this.fg) {
				this.fg = this.createGroup();
			}

			this.attachments.forEach((attachment) => {
				if (!this.fg.contains(`${attachment.docNumber}`)) {
					this.fg.addControl(`${attachment.docNumber}`, this.fb.control(''));
				}

				this.fg.controls[`${attachment.docNumber}`].setValue(attachment.description);
			});
		}
	}

	createGroup(): UntypedFormGroup {
		const group = this.fb.group({});
		this.attachments.forEach((attach) => {
			group.addControl('' + attach.docNumber, this.fb.control(''));
		});
		return group;
	}

	attachment_Click(docNum: number, desc: string) {
		this.openAttachment.emit({ docNum, desc });
	}

	delete(attachment: Attachment) {
		this.deleteAttachment.emit(attachment);
		this.fg.removeControl(`${attachment.docNumber}`);
	}

	getIcon(type: string) {
		const docType = type ? type.toLowerCase() : '';
		let icon = '';
		switch (docType) {
			case 'pdf':
				icon = 'fal fa-file-pdf';
				break;
			case 'tif':
			case 'tiff':
			case 'jpg':
			case 'eps':
			case 'png':
				icon = 'fal fa-file-image';
				break;
			case 'zzz':
				icon = 'fal fa-folder';
				break;
			case 'html':
				icon = 'fal fa-file-code';
				break;
			case 'indd':
			case 'pub':
			case 'qrp':
				icon = 'fal fa-file-contract';
				break;
			case 'csv':
				icon = 'fal fa-file-csv';
				break;
			case 'xslb':
			case 'xlsx':
				icon = 'fal fa-file-excel';
				break;
			case 'msg':
				icon = 'fal fa-envelope';
				break;
			case 'wmv':
				icon = 'fal fa-file-video';
				break;
			case 'm4a':
				icon = 'fal fa-file-audio';
				break;
			case 'txt':
			case 'wpd':
				icon = 'fal fa-file-alt';
				break;
			case 'ppsx':
			case 'pps':
			case 'ppt':
			case 'pptx':
				icon = 'fal fa-file-powerpoint';
				break;
			case 'doc':
			case 'docx':
			case 'dotx':
			case 'rtf':
				icon = 'fal fa-file-word';
				break;
			case 'dwg':
				icon = 'fal fa-map-marked';
				break;
			case 'shw':
				icon = 'fal fa-presentation';
				break;
			case 'vsd':
			case 'vsdx':
				icon = 'fal fa-sitemap';
				break;
			default:
				icon = 'fal fa-file';
				break;
		}
		return icon;
	}

	updateTextAreaBlur(e: any, attachment: Attachment) {
		let updatedDesc = (e.target.value || '').trim();
		if (attachment.focus && attachment.description !== updatedDesc) {
			this.updateAttachDescription.emit({
				...attachment,
				description: updatedDesc,
			});
		}

		attachment.focus = false;
	}

	updateAttachClick(attachment: Attachment) {
		let updatedDesc = this.fg.controls[`${attachment.docNumber}`].value;
		if (attachment.focus && attachment.description !== updatedDesc) {
			attachment.description = updatedDesc;
			this.updateAttachDescription.emit(attachment);
			attachment.focus = false;
		}
		attachment.focus = false;
	}

	undoEditFile(id: number) {
		const attachFile = this.attachments.find((a) => a.attachment_Id === id);

		if (attachFile) {
			this.fg.controls[attachFile.docNumber].setValue(attachFile.description);
			attachFile.focus = false;
		}
	}

	setFocus(id: number) {
		const attachFile = this.attachments.find((a) => a.attachment_Id === id);
		if (attachFile) {
			attachFile.focus = true;
		}
	}

	getAttacher(id: number) {
		const file = this.attachments.filter((d) => d.attachment_Id === id);
		if (file) {
			const user = this.users.filter((u) => u.user_Id === file[0].addedBy);
			if (user && user.length === 1) {
				return user[0].firstName + ' ' + user[0].lastName;
			}
		}
		return '';
	}
}
